import { d as defineBuiltIn$1 } from '../internals/define-built-in.js';
import { e as errorToString$1 } from '../internals/error-to-string.js';

var defineBuiltIn = defineBuiltIn$1;
var errorToString = errorToString$1;

var ErrorPrototype = Error.prototype;

// `Error.prototype.toString` method fix
// https://tc39.es/ecma262/#sec-error.prototype.tostring
if (ErrorPrototype.toString !== errorToString) {
  defineBuiltIn(ErrorPrototype, 'toString', errorToString);
}
